import { render, staticRenderFns } from "./ReplyCommentForm.vue?vue&type=template&id=350c56e2&scoped=true&"
import script from "./ReplyCommentForm.vue?vue&type=script&lang=js&"
export * from "./ReplyCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./ReplyCommentForm.vue?vue&type=style&index=0&id=350c56e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350c56e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VForm,VProgressCircular})
